export default __webpack_public_path__ + "static/ReferralPage--hero-034d7adcfa1490b391225aadc42aa374.png";